import { render, staticRenderFns } from "./LayoutElementTypeText.vue?vue&type=template&id=45d56b6d&scoped=true"
import script from "./LayoutElementTypeText.vue?vue&type=script&lang=js"
export * from "./LayoutElementTypeText.vue?vue&type=script&lang=js"
import style0 from "./LayoutElementTypeText.vue?vue&type=style&index=0&id=45d56b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d56b6d",
  null
  
)

export default component.exports